import { useTranslation } from '@msdk/common'
import { Chip, styled } from '@msdk/ui'
import { ScheduleOutlined } from '@mui/icons-material'

import { CodeType, useCodeContext } from './CodeContext'

const StyledCodeChip = styled(Chip)`
  border: none;
  & .MuiChip-icon {
    background-color: transparent;
  }
`

interface CodeValidationProps {
  codeType: CodeType
}

export function CodeValidation({ codeType }: CodeValidationProps) {
  const t = useTranslation()
  const { face, nfc } = useCodeContext()
  const codeInfo = codeType === 'face' ? face : nfc

  return (
    <>
      {!codeInfo.isCodeExpired && (
        <StyledCodeChip
          label={`${t('LBL_NGID_CODE_VALID_FOR', 'Code is valid for')} ${codeInfo.remainingTime}`}
          icon={<ScheduleOutlined />}
          color="info"
          variant="outlined"
        />
      )}
      {codeInfo.isCodeExpired && (
        <StyledCodeChip
          label={`${t('LBL_NGID_CODE_EXPIRED', 'Code is expired')}`}
          icon={<ScheduleOutlined color="error" />}
          color="error"
          variant="outlined"
        />
      )}
    </>
  )
}
